import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import Modal from '../../components/modal';
import Input from '../../components/Input';

const AddCources = ({ isModalOpen, setIsModalOpen, closeModal }) => {
  const [planData, setPlanData] = useState({
    name: '',
    timePeriod: '',
    courseDuration: '',
    file: null,
    description: '',
    price: '',
    category: '',
    youtubeVideoLink: '',
    lessons: '',
    bulletPoints: [], // Array for bullet points
    additionalImages: [] // Array for additional image files
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [additionalImagePreviews, setAdditionalImagePreviews] = useState([]);
  const [loading, setLoader] = useState(false);
  const [category, setCategory] = useState([]);
  const [bulletPointInput, setBulletPointInput] = useState(''); // Temporary input for bullet points

  const isFormValid = () => {
    return (
      planData.name &&
      planData.timePeriod &&
      planData.courseDuration &&
      planData.file &&
      planData.price &&
      planData.lessons &&
      planData.category
    );
  };

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/category', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCategory(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [planData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPlanData((prev) => ({
        ...prev,
        file: file
      }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleClick = () => {
    document.getElementById('fileInput').click();
  };

  const handleRemoveImage = () => {
    setPlanData((prev) => ({
      ...prev,
      file: null
    }));
    setImagePreview(null);
  };

  const handleBulletPointInputChange = (e) => {
    setBulletPointInput(e.target.value);
  };

  const addBulletPoint = () => {
    if (bulletPointInput.trim()) {
      setPlanData((prev) => ({
        ...prev,
        bulletPoints: [...prev.bulletPoints, bulletPointInput.trim()]
      }));
      setBulletPointInput('');
    }
  };

  const removeBulletPoint = (index) => {
    setPlanData((prev) => ({
      ...prev,
      bulletPoints: prev.bulletPoints.filter((_, i) => i !== index)
    }));
  };

  const handleAdditionalImagesChange = (e) => {
    const files = Array.from(e.target.files);
    setPlanData((prev) => ({
      ...prev,
      additionalImages: [...prev.additionalImages, ...files]
    }));

    // Generate preview URLs
    const previewUrls = files.map((file) => URL.createObjectURL(file));
    setAdditionalImagePreviews((prev) => [...prev, ...previewUrls]);
  };

  const removeAdditionalImage = (index) => {
    const newFiles = [...planData.additionalImages];
    newFiles.splice(index, 1);
    setPlanData((prev) => ({
      ...prev,
      additionalImages: newFiles
    }));

    const newPreviews = [...additionalImagePreviews];
    newPreviews.splice(index, 1);
    setAdditionalImagePreviews(newPreviews);
  };

  const uploadAdditionalImages = async (files) => {
    const uploadedUrls = [];
    for (const file of files) {
      const formdata = new FormData();
      formdata.append('images', file);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };

      try {
        const response = await fetch(
          'https://file-upload-ashen.vercel.app/api/upload',
          requestOptions
        );
        const result = await response.text();
        const data = JSON.parse(result);
        if (data?.success === true) {
          uploadedUrls.push(data?.data[0]);
        } else {
          toast.error('Error uploading additional images');
          return null;
        }
      } catch (error) {
        console.error(error);
        toast.error('Error uploading additional images');
        return null;
      }
    }
    return uploadedUrls;
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    // Upload main image
    const formdata = new FormData();
    formdata.append('images', planData.file);

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    try {
      const response = await fetch(
        'https://file-upload-ashen.vercel.app/api/upload',
        requestOptions
      );
      const result = await response.text();
      const data = JSON.parse(result);

      if (data?.success === true) {
        // Upload additional images
        const additionalImageUrls = await uploadAdditionalImages(planData.additionalImages);
        if (!additionalImageUrls) {
          setLoader(false);
          return;
        }

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Access-Control-Allow-Origin', '*');
        myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
        const raw = JSON.stringify({
          name: planData?.name,
          duration: Number(planData?.courseDuration),
          periodType: planData?.timePeriod,
          description: planData?.description,
          category: planData?.category,
          youtubeVideoLink: planData?.youtubeVideoLink,
          image: data?.data[0],
          price: Number(planData?.price),
          lesson: planData?.lessons,
          bulletPoints: planData?.bulletPoints,
          additionalImages: additionalImageUrls
        });

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };

        const courseResponse = await fetch(
          'https://quran-backend-theta.vercel.app/v1/admin/course',
          requestOptions
        );
        const courseResult = await courseResponse.text();
        const courseData = JSON.parse(courseResult);

        if (courseData?.success === false) {
          if (courseData?.message === 'Expired') {
            localStorage.clear();
            window.location.reload();
          } else {
            toast.error(courseData?.message);
          }
        } else {
          toast.success('Course added successfully!');
          window.location.reload();
        }
      } else {
        toast.error('Error uploading main image');
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred');
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="p-3 flex justify-between items-center">
          <h1 className="capitalize h4 font-medium">Add Course</h1>
          <MdClose onClick={() => setIsModalOpen(false)} size={25} />
        </div>
        <hr />
        <div className="p-5">
          <form onSubmit={bannerSubmit}>
            <div className="flex gap-5 flex-wrap">
              <div className="w-[48%]">
                <Input
                  label={'Course Name'}
                  placeholder={'name'}
                  className={'bg-gray-100 px-2 w-full'}
                  name="name"
                  value={planData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="w-[48%]">
                <label className="block mb-2 text-sm text-gray-900 font-medium">
                  Course Category
                </label>
                <select
                  name="category"
                  value={planData.category}
                  onChange={handleChange}
                  className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                >
                  <option>Select Category</option>
                  {category?.map((item, index) => (
                    <option key={index} value={item?._id}>
                      {item?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="w-[48%]">
                <label className="block mb-2 text-sm text-gray-900 font-medium">Duration</label>
                <select
                  name="courseDuration"
                  value={planData.courseDuration}
                  onChange={handleChange}
                  className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                >
                  <option>Select Duration</option>
                  {[...Array(12).keys()].map((i) => (
                    <option key={i} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>

              <div className="w-[48%]">
                <label className="block mb-2 text-sm text-gray-900 font-medium">Period Type</label>
                <select
                  name="timePeriod"
                  value={planData.timePeriod}
                  onChange={handleChange}
                  className="w-full py-3 outline-none bg-lightGray p-2.5 text-black placeholder:text-primary rounded-md"
                >
                  <option>Select Type</option>
                  <option value="month">Month</option>
                  <option value="year">Year</option>
                </select>
              </div>

              <div className="w-[100%]">
                <Input
                  label={'Lessons'}
                  placeholder={'Enter number of lessons'}
                  className={'bg-gray-100 px-2 w-full'}
                  name="lessons"
                  value={planData.lessons}
                  onChange={handleChange}
                />
              </div>

              <div className="w-[100%]">
                <Input
                  label={'Price'}
                  placeholder={'Enter price'}
                  className={'bg-gray-100 px-2 w-full'}
                  name="price"
                  value={planData.price}
                  onChange={handleChange}
                  type="number"
                />
              </div>

              <div className="w-[100%]">
                <label>Description</label>
                <textarea
                  rows={5}
                  className="w-full bg-[#F6F6F6] py-3 px-5"
                  name="description"
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="w-[100%]">
                <Input
                  label={'Youtube Video Link'}
                  placeholder={'Enter Link'}
                  className={'bg-gray-100 px-2 w-full'}
                  name="youtubeVideoLink"
                  value={planData.youtubeVideoLink}
                  onChange={handleChange}
                  type="url"
                />
              </div>

              <div className="w-[100%]">
                <label>Bullet Points</label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={bulletPointInput}
                    onChange={handleBulletPointInputChange}
                    className="w-full bg-[#F6F6F6] py-3 px-5"
                    placeholder="Enter a bullet point"
                  />
                  <button
                    type="button"
                    onClick={addBulletPoint}
                    className=" bg-secondary text-white px-4 py-2 rounded-md"
                  >
                    Add
                  </button>
                </div>
                <div className="mt-2">
                  {planData.bulletPoints.map((point, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <span>{point}</span>
                      <button
                        type="button"
                        onClick={() => removeBulletPoint(index)}
                        className="text-red-500"
                      >
                        <MdClose size={16} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <label>Image</label>
              <div
                className="w-full border-dashed border-[#9E9E9E] bg-[#F6F6F6] border-2 rounded-lg p-4 cursor-pointer"
                onClick={handleClick}
              >
                <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-20 rounded-2xl">
                  <MdOutlineFileUpload size={30} className="text-primary" />
                </div>
                <p className="text-primary font-medium mt-3 text-center">
                  <span className="text-secondary">Click here</span> to upload or drop Course Image
                </p>

                {imagePreview && (
                  <div className="relative w-full h-32 mt-4">
                    <img
                      src={imagePreview}
                      alt="Selected Image"
                      className="w-full h-full object-cover rounded-md"
                    />
                    <button
                      type="button"
                      onClick={handleRemoveImage}
                      className="absolute top-0 right-0 bg-red-500 text-white p-2 rounded-full"
                    >
                      <MdClose size={20} />
                    </button>
                  </div>
                )}
                <input
                  id="fileInput"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleFileChange}
                />
              </div>

              <div className="w-[100%]">
                <label>Additional Images</label>
                <div
                  className="w-full border-dashed border-[#9E9E9E] bg-[#F6F6F6] border-2 rounded-lg p-4 cursor-pointer"
                  onClick={() => document.getElementById('additionalImagesInput').click()}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    e.preventDefault();
                    const files = Array.from(e.dataTransfer.files);
                    setPlanData((prev) => ({
                      ...prev,
                      additionalImages: [...prev.additionalImages, ...files]
                    }));
                    const previewUrls = files.map((file) => URL.createObjectURL(file));
                    setAdditionalImagePreviews((prev) => [...prev, ...previewUrls]);
                  }}
                >
                  <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-20 rounded-2xl">
                    <MdOutlineFileUpload size={30} className="text-primary" />
                  </div>
                  <p className="text-primary font-medium mt-3 text-center">
                    <span className="text-secondary">Click here</span> to upload or drop additional
                    images
                  </p>
                  <input
                    id="additionalImagesInput"
                    type="file"
                    multiple
                    style={{ display: 'none' }}
                    onChange={handleAdditionalImagesChange}
                  />
                </div>
                <div className="mt-4 grid grid-cols-3 gap-4">
                  {additionalImagePreviews.map((preview, index) => (
                    <div key={index} className="relative">
                      <img
                        src={preview}
                        alt={`Additional Image ${index + 1}`}
                        className="w-full h-32 object-cover rounded-md"
                      />
                      <button
                        type="button"
                        onClick={() => removeAdditionalImage(index)}
                        className="absolute top-0 right-0 bg-red-500 text-white p-1 rounded-full"
                      >
                        <MdClose size={16} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {loading ? (
              <button
                disabled
                type="button"
                className="bg-primary w-full text-center mt-3 py-2.5 rounded-lg text-white font-semibold cursor-pointer"
              >
                Loading...
              </button>
            ) : (
              <button
                type="submit"
                className={`w-full mt-3  bg-secondary py-2.5 rounded-md text-white text-sm font-medium ${
                  !isFormValid() && 'cursor-not-allowed opacity-50'
                }`}
                disabled={!isFormValid()}
              >
                Submit
              </button>
            )}
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default AddCources;
